var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.team)?_c('div',[_c('InvoiceControls',{staticClass:"d-print-none"}),_c('InvoiceForm')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }